{
  "name": "truthengine-hub",
  "version": "1.7.6",
  "scripts": {
    "ng": "ng",
    "start": "node scripts/set-config.cjs devlocal && ng serve",
    "local": "node scripts/set-config.cjs local && ng serve",
    "dev": "node scripts/set-config.cjs dev && ng serve",
    "devlocal": "node scripts/set-config.cjs devlocal && ng serve",
    "build": "ng build --configuration production",
    "builduat": "node scripts/set-config.cjs uat && ng build --configuration production",
    "builddev": "node scripts/set-config.cjs dev && node --max_old_space_size=8192 node_modules/@angular/cli/bin/ng build -c development",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:ci": "ng test --no-watch --browsers=ChromeHeadlessCI --code-coverage",
    "test:e2e": "playwright test",
    "build-theme": "npx devextreme-cli build-theme --input-file=src/themes/te-theme.config.json --output-file=src/themes/dx.te-light.css",
    "postinstall": "npm run build-theme",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~21.2.13",
    "@angular/cdk": "~21.2.11",
    "@angular/common": "~21.2.13",
    "@angular/compiler": "~21.2.13",
    "@angular/core": "~21.2.13",
    "@angular/forms": "~21.2.13",
    "@angular/material": "~21.2.11",
    "@angular/platform-browser": "~21.2.13",
    "@angular/platform-browser-dynamic": "~21.2.13",
    "@angular/router": "~21.2.13",
    "@azure/msal-angular": "~5.2.4",
    "@azure/msal-browser": "~5.10.1",
    "@types/file-saver": "~2.0.7",
    "@types/uuid": "~10.0.0",
    "dayjs": "~1.11.20",
    "dayjs-business-days2": "~1.2.2",
    "devextreme": "~25.2.7",
    "devextreme-angular": "~25.2.7",
    "devextreme-schematics": "~1.15.0",
    "exceljs": "~4.3.0",
    "file-saver": "~2.0.5",
    "ngx-mat-select-search": "^8.0.6",
    "ngx-toastr": "~19.0.0",
    "rxjs": "~7.8.2",
    "tslib": "~2.8.1",
    "typescript": "~5.9.3",
    "uuid": "~10.0.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "~21.3.1",
    "@angular-eslint/eslint-plugin": "~21.3.1",
    "@angular-eslint/eslint-plugin-template": "~21.3.1",
    "@angular-eslint/schematics": "~21.3.1",
    "@angular-eslint/template-parser": "~21.3.1",
    "@angular/build": "~21.2.11",
    "@angular/cli": "~21.2.11",
    "@angular/compiler-cli": "~21.2.13",
    "@playwright/test": "^1.63.0",
    "@types/jasmine": "~5.1.4",
    "@types/node": "~22.15.0",
    "@typescript-eslint/eslint-plugin": "~8.59.3",
    "@typescript-eslint/parser": "~8.59.3",
    "devextreme-cli": "~1.15.0",
    "devextreme-themebuilder": "25.2.7",
    "eslint": "~8.57.0",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0"
  }
}
